import { Modal } from '@/components/admin/Modal';
import { Button } from '@/components/ui/button';
import { CopyButton } from '@/components/ui/copy-button';
import type { ApiKeyWithSecret } from '@innermate/shared';
import { AlertTriangle } from 'lucide-react';

interface Props {
  open: boolean;
  onClose: () => void;
  secretKey: ApiKeyWithSecret | null;
}

export function RevealSecretDialog({ open, onClose, secretKey }: Props) {
  if (!open || !secretKey) return null;
  return (
    <Modal open={open} onClose={onClose} title="API 키 발급 완료" size="md" layer="high">
      <div className="space-y-4">
        <div className="rounded-md border border-amber-500/30 bg-amber-500/5 px-3 py-2 text-sm text-amber-700 dark:text-amber-400">
          <div className="flex items-start gap-2">
            <AlertTriangle className="size-4 mt-0.5 shrink-0" />
            <div>
              <p className="font-medium">아래 키는 이 화면을 닫으면 다시 볼 수 없습니다.</p>
              <p className="mt-1 text-xs">
                안전한 곳에 즉시 저장하세요. 잃어버리면 새 키를 발급받아야 합니다.
              </p>
            </div>
          </div>
        </div>

        <div>
          <div className="text-xs uppercase tracking-wider text-foreground-muted mb-1">이름</div>
          <div className="text-sm">{secretKey.name}</div>
        </div>

        <div>
          <div className="text-xs uppercase tracking-wider text-foreground-muted mb-1">시크릿</div>
          <div className="flex items-center gap-2">
            <code className="flex-1 min-w-0 break-all rounded-md border border-border bg-surface-muted/40 px-3 py-2 text-xs font-mono">
              {secretKey.secret}
            </code>
            <CopyButton text={secretKey.secret} size="sm" label="키 복사" />
          </div>
        </div>

        <div className="flex justify-end pt-2">
          <Button onClick={onClose}>저장했습니다</Button>
        </div>
      </div>
    </Modal>
  );
}
